import React from 'react';

import type { AuthStateSetterInput, LoginResult } from './types';

export interface AuthContextType {
  isAuthorized: boolean;
  login: (data: {
    email: string;
    password?: string;
    userCode?: string;
    session?: string;
  }) => Promise<LoginResult>;
  logout: (route?: string) => Promise<void>;
  setAuthState: (data: AuthStateSetterInput) => Promise<void>;
}

export const AuthContext = React.createContext({} as AuthContextType);
